<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"><span class="bold">To my dear Sandra,<br/>1950-2014</span></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?bd532e5a